import clsx from 'clsx'
import styled from 'styled-components'

type CommunityNameProps = {
  label: string
  className?: string
  hasUnseenNewsOrCommentReplies?: boolean
  hasBox?: boolean
}

const CommunityText = styled.div`
  max-height: var(--spacer-6);
  transition: opacity ease 100ms;
  width: 8rem;

  & span {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 0.875rem;
    line-height: 1.5;
    text-overflow: ellipsis;
    word-break: break-word;
    transition: opacity ease 500ms;
  }
`

export const CommunitiesListName = ({
  label,
  className,
  hasUnseenNewsOrCommentReplies = false
}: CommunityNameProps) => {
  return (
    <>
      <CommunityText className={clsx('_d-flex _flex-1 _align-items-center', className)}>
        <div className='_d-flex _flex-1 _align-items-center text-display'>
          <span
            className={clsx('_text-left', {
              '_font-weight-bold': hasUnseenNewsOrCommentReplies
            })}>
            {label}
          </span>
        </div>
      </CommunityText>
    </>
  )
}
